'use client'

import { ConsultantBanner } from '@/constants/messageConstants'
import { UserContext } from '@/providers/user-provider'
import { DictionaryText, InlineNotification, NotificationVariant } from '@lib-components'
import { getFullName } from '@lib-helpers'
import { ReactElement, use } from 'react'

const formatCompanyLabel = (
    company: {
        companyName?: string | null
        companyCode?: string | null
    } | null,
): string => {
    if (!company) return ''
    const name = company.companyName?.trim() ?? ''
    const code = company.companyCode?.trim() ?? ''
    if (name && code) return `${name} (${code})`
    return name || code
}

export const ConsultantSessionBanner = (): ReactElement => {
    const { user, getComplianceCompanyOfUser } = use(UserContext)

    const userName = getFullName(user)
    const complianceCompany = getComplianceCompanyOfUser()
    const complianceCompanyLabel = formatCompanyLabel(complianceCompany)

    return (
        <InlineNotification
            dismissable={false}
            className="mb-4"
            variant={NotificationVariant.WARNING}
            message={
                <div className="mx-auto max-w-6xl space-y-1">
                    <p>
                        <DictionaryText textKey={ConsultantBanner.LOGGED_IN_AS} replacer={{ userName }} />
                    </p>
                    {complianceCompanyLabel ? (
                        <p>
                            <DictionaryText
                                textKey={ConsultantBanner.LINKING}
                                replacer={{ companyName: complianceCompanyLabel }}
                            />
                        </p>
                    ) : null}
                </div>
            }
        />
    )
}
